export default __webpack_public_path__ + "static/media/friends.d5cb0ade.svg";